export const MessageStatus = {
  WAITING: "WAITING",
  START: "START",
  END: "END",
  IN_PROGRESS: "IN_PROGRESS",
  OFFLINE: "OFFLINE",
  ASSIGNED: "ASSIGNED",
  AUTO_CLOSURE_WARNING: "AUTO_CLOSURE_WARNING",
  AUTO_CLOSURE: "AUTO_CLOSURE",
  TRANSFERRED: "TRANSFERRED",
};

export const ChatExpirationEvents = {
  START_WAITING: "START_WAITING",
  FREEZE: "FREEZE",
  CANCEL_WAITING: "CANCEL_WAITING",
  MSGS_LOADED: "MSGS_LOADED"
};
